<template>
  <div class="hrIndexContainer">
    <el-row type="flex" justify="space-around" style="margin: 20px 0px">
      <el-col :span="23">
        <el-row :gutter="20">
          <el-col
            v-for="post in postInfos"
            :key="post.label"
            :lg="6"
            :xl="6"
            :md="12"
            :sm="12"
            :xs="12"
          >
            <el-button type="plain" style="width: 100%; margin-top: 20px">
              <div v-if="isMob" class="postInfoMob">
                <el-col :span="12"
                  ><zr-icon class="zrIcon" :icon="post.icon"></zr-icon
                ></el-col>
                <el-col :span="12">
                  <div>
                    {{ post.num }}
                    <br /><span>{{ post.label }}</span>
                  </div>
                </el-col>
              </div>
              <div v-else class="postInfo">
                <el-col :span="12"
                  ><zr-icon class="zrIcon" :icon="post.icon"></zr-icon
                ></el-col>
                <el-col :span="12">
                  <div>
                    {{ post.num }}
                    <br /><span>{{ post.label }}</span>
                  </div>
                </el-col>
              </div>
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-around" style="margin: 20px 0px">
      <el-col :span="23">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="card-head">招聘信息</span>
            <div style="float: right">
              <el-button
                v-if="showPublish"
                style="padding: 3px 0; margin-right: 15px; font-size: 14px"
                type="primary"
                @click="publishPosition"
                >职位发布 <i class="fa fa-plus"></i
              ></el-button>
              <el-button
                style="padding: 3px 0; margin-right: 15px; font-size: 14px"
                type="primary"
                @click="gotoRecruitInfo"
                >更多 <zr-icon icon="chevron-circle-right"></zr-icon
              ></el-button>
            </div>
          </div>
          <PostList :post-list="postList"></PostList>
        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-around" style="margin: 20px 0px">
      <el-col :span="23">
        <el-row :gutter="30">
          <el-col :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
            <el-card class="box-card" style="margin-top: 10px">
              <div slot="header" class="clearfix">
                <span class="card-head">热门职位排行</span>
              </div>
              <div
                v-for="(value, index) in hotList"
                :key="index"
                class="text item"
              >
                {{ index + 1 }} 、 {{ `${value.postName}(${value.count})` }}
              </div>
            </el-card>
          </el-col>
          <el-col :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
            <el-card class="box-card" style="margin-top: 10px">
              <div slot="header" class="clearfix">
                <span class="card-head">冷门职位排行</span>
              </div>
              <div
                v-for="(value, index) in coldList"
                :key="index"
                class="text item"
              >
                {{ index + 1 }} 、 {{ `${value.postName}(${value.count})` }}
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-around" style="margin: 20px 0px">
      <el-col :span="23">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="card-head">统计信息</span>
          </div>
          <el-row :gutter="40">
            <el-col :span="12" :xs="24">
              <zr-echarts-pie
                v-if="showPie"
                style="width: 100%"
                :option="pieOption"
              ></zr-echarts-pie>
            </el-col>
            <el-col :span="12" :xs="24">
              <zr-echarts-bar
                v-if="showBar"
                style="width: 100%"
                :option="barOption"
              ></zr-echarts-bar>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PostList from "^/recruit/list";
import {
  searchMainNum,
  searchPostInfoForMain,
  searchRankList,
  searchPhaseStatistic,
  searchPostStatistic,
} from "@/api/recruit/hr/index";
import isMobile from "@/utils/device";
const isMb = isMobile();

export default {
  name: "Index",
  components: { PostList },
  data() {
    return {
      isMob: isMb,
      showPie: true,
      showBar: true,
      postInfos: [
        { icon: "list", num: 0, label: "在线职位" },
        { icon: "puzzle-piece", num: 0, label: "职位模板" },
        { icon: "paper-plane", num: 0, label: "简历投递" },
        { icon: "star", num: 0, label: "简历收藏" },
      ],
      postList: [],
      coldList: [],
      hotList: [],
      pieData: [],
      barData: {},
      pieOption: {},
      barOption: {},
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
    }),
    showPublish() {
      return this.curRole == "hrAdmin" || this.curRole == "admin";
    },
  },
  async created() {
    await this.initMainNum();
    await this.initPostList();
    await this.initRankList();
    await this.initPieOption();
    await this.initBarOption();
  },
  methods: {
    async initRankList() {
      const res = await searchRankList();
      if (res.success) {
        const data = res.data;
        this.coldList = data.cold;
        this.hotList = data.hot;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initPostList() {
      const res = await searchPostInfoForMain({ count: 3, searchType: "self" });
      if (res.success) {
        this.postList = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initMainNum() {
      const res = await searchMainNum();
      if (res.success) {
        const data = res.data;
        this.postInfos[0].num = data.postOnlineCount;
        this.postInfos[1].num = data.templateCount;
        this.postInfos[2].num = data.postSendCount;
        this.postInfos[3].num = data.collectCount;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    publishPosition() {
      this.$router.push("/positionEdit/index");
    },
    gotoRecruitInfo() {
      this.$router.push("/positionManagement/index");
    },
    async initPieOption() {
      this.showPie = false;
      const res = await searchPhaseStatistic();
      if (res.success) {
        this.pieData = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      const typeArray = this.pieData.map((value) => value.name);
      let option = {
        title: {
          text: "学历统计",
          x: "center",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: typeArray,
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
            },
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}份 ({d}%)",
        },
        series: [
          {
            name: "最高学历",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: this.pieData,
            label: {
              normal: {
                show: true,
                position: "outside",
                formatter: "{b}({c}份-{d}%)",
              },
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.pieOption = option;
      this.$nextTick(() => {
        this.showPie = true;
      });
    },
    async initBarOption() {
      this.showBar = false;
      const res = await searchPostStatistic();
      if (res.success) {
        this.barData = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      let option = {
        title: {
          text: "职位类型统计",
        },
        legend: {
          data: ["职位数量"],
        },
        calculable: false,
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
            },
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.barData.datax,
            axisLabel: {
              interval: 0,
              rotate: -30,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "职位数量",
            type: "bar",
            data: this.barData.datay,
            label: {
              normal: {
                show: true,
                position: "outside",
                formatter: "{c}个",
              },
            },
            barMaxWidth: 40,
            barCategoryGap: "10%",
            barGap: "10%",
          },
        ],
      };
      this.barOption = option;
      this.$nextTick(() => {
        this.showBar = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card-head {
  font-size: 16px;
  font-weight: bold;
}
.postInfo {
  width: 200px;
  margin-left: 10px;
  text-align: center;
  align-items: center;
  font-size: 30px;

  span {
    font-size: 18px;
  }

  .zrIcon {
    width: 50%;
    height: 50%;
  }
}
.postInfoMob {
  width: 100px;
  margin-left: 10px;
  text-align: center;
  align-items: center;
  font-size: 30px;

  span {
    font-size: 18px;
  }

  .zrIcon {
    width: 50%;
    height: 50%;
  }
}
._echartsMap {
  min-width: 400px;
}
</style>
